const EMAIL_ADDRESS_PATTERN = /[^\s@]+@[^\s@]+\.[^\s@]+/gi;

const LINK_PATTERN = new RegExp(
  '(?:[a-z][a-z0-9+.-]*:\\/\\/\\S+)' +
    '|(?:\\bwww\\.\\S+)' +
    '|(?:\\b[a-z0-9](?:[a-z0-9-]*[a-z0-9])?(?:\\.[a-z0-9-]+)*' +
    '\\.(?:com|net|org|gov|edu|mil|int|io|co|us|uk|ca|au|de|fr|nl|in|ru|cn|info|biz|xyz|link|click|shop|site|online|top|app|dev)\\b)',
  'i',
);

const IMAGE_EXTENSIONS = [
  '.jpg',
  '.jpeg',
  '.png',
  '.gif',
  '.bmp',
  '.webp',
  '.heic',
  '.heif',
  '.tif',
  '.tiff',
];

export const LINK_MESSAGE =
  'Links are not allowed in chat messages. Please describe the issue in plain text instead.';

export const IMAGE_ONLY_MESSAGE =
  'Only image attachments are allowed in chat. Please upload documents through the vendor registration form.';

/** Accept filter for chat file inputs; the server enforces the same list. */
export const IMAGE_ACCEPT = IMAGE_EXTENSIONS.join(',');

export function containsLink(text: string | null | undefined): boolean {
  if (!text) return false;
  return LINK_PATTERN.test(text.replace(EMAIL_ADDRESS_PATTERN, ' '));
}

export function isImageAttachment(file: File | null | undefined): boolean {
  if (!file) return false;
  const name = (file.name || '').toLowerCase();
  return (
    file.type.startsWith('image/') &&
    IMAGE_EXTENSIONS.some((extension) => name.endsWith(extension))
  );
}
